
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["paymentSummary_svg__icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1024 1024","xmlns":"http://www.w3.org/2000/svg","width":"128","height":"128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M127.208 89.632H899.56c26.622 0 48.36-20.084 48.36-44.737 0-24.653-21.738-44.816-48.36-44.816H127.208c-26.622 0-48.282 20.006-48.282 44.737 0 24.496 21.66 44.816 48.282 44.816zm292.684 407.364h1.575-1.575zm555.674-317.652h-927.2a49.385 49.385 0 00-48.36 50.093v744.548c0 27.41 21.738 50.015 48.36 50.015h927.2a49.385 49.385 0 0048.36-50.015V229.28a49.148 49.148 0 00-48.36-49.936zM671.068 647.276c26.622 0 48.282 20.084 48.282 44.737 0 24.496-21.66 44.659-48.282 44.659H555.286v108.3c0 27.409-19.533 50.014-43.32 50.014-23.786 0-43.32-22.605-43.32-50.015V736.987H353.101c-26.622 0-48.282-20.085-48.282-44.737 0-24.575 21.66-44.738 48.282-44.738h115.545v-64.35H353.101c-26.622 0-48.282-20.005-48.282-44.737 0-24.495 21.66-44.659 48.282-44.659h64.113l-23.786-46.785-27.883-55.292c-12.287-24.416-5.277-53.401 15.832-64.98 21.187-11.42 48.597-.787 60.805 23.315l22.526 44.5 1.182 2.049 23.156 45.682h.236l23.55 46.313 23.472-46.313h.236l23.157-45.682 1.181-2.048 22.605-44.501c12.287-24.417 39.618-34.814 60.648-23.314 21.187 11.42 28.197 40.563 15.91 64.98l-27.882 55.291-23.787 46.785h-.236 63.01c26.622 0 48.361 20.006 48.361 44.659 0 24.574-21.739 44.738-48.36 44.738H555.128v64.113h115.94z"}})])
          )
        }
      }
    